<template>
  <div class="housing-locality-apartments print-break-before">

    <template>

      <div class="drawer">
          <h2 class="h2 text-align-center mb-5">
            {{translate('Vapaana olevat asunnot')}}
          </h2>
      </div>

      <LoadSpinner v-if="loading"/>

      <div
          v-if="apartments.length > 0"
          class="apartment-search-full__grid listing-card-grid"
        >
          <div class="listing-card-grid__grid narrow-grid">
            <div
              v-for="apartment in visibleApartments"
              class="listing-card-grid__column"
            >
              <ApartmentCard
                :apartment="apartment"
                class="listing-card-grid__item"
              />
            </div>
          </div>
        </div>
        <div v-if="!loading && apartments.length == 0"
          class="listing-not-found"
        >
            {{translate('Vapaita asuntoja ei löytynyt')}}
        </div>

        <div
          class="apartment-search-full__load-more-container print-hide"
        >
          <button
            v-if="apartmentsVisible < apartments.length"
            class="apartment-search-full__load-more btn"
            :class="`btn--green`"
            @click="apartmentsVisible += step"
          >
            <template>
              {{translate('Katso lisää vapaita asuntoja')}}
            </template>
          </button>
        </div>


    </template>
  </div>
</template>

<script>
  import axios from 'axios';

  import globals from '../lib/globals';
  import utils from './mixins/utils';
  import LoadSpinner from './components/LoadSpinner';
  import ApartmentCard from './components/ApartmentCard';


  export default {
    components: {
      LoadSpinner,
      ApartmentCard,
    },
    mixins: [
      utils.translate,
    ],
    props: {
      housingLocality: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        default: 'default',
      },
    },
    data() {
      return {
        loading: false,
        apartments: [],
        apartmentsVisible: 6,
        step: 6,
      };
    },
    computed: {
      visibleApartments() {
        return this.apartments.slice(0, this.apartmentsVisible)
      }
    },
    async beforeMount() {
      this.loading = true;
      const url = `${globals.urlIntegrationApi}/public/available-apartments-by-housing-locality/${this.housingLocality}`;
      const response = await axios.get(url);
      const apartments = response.data;

      this.apartments = apartments.sort((a, b) => {
        const aArea = a.mpc_pinta_ala;
        const bArea = b.mpc_pinta_ala;
        return aArea === bArea ? 0 : (aArea < bArea ? -1 : 1);
      });

      this.loading = false;
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .narrow-grid .listing-card-grid__column {
    display: flex;
    padding: 0 r(12) r(20);
    width: 100%;

    @include media-breakpoint-up(md) {
      width: 50%;
    }

    @include media-breakpoint-up(xl) {
      width: 33.3%;
    }
  }
  .listing-not-found {
    font-size: $ff-lato;
    padding-left: r(8);
    text-align: center;
  }

  .drawer__header.drawer__header-no-border {
    border-bottom-color: transparent;
  }

</style>
